import React from 'react'
import { BuildCircle as BulkIcon } from '@mui/icons-material'
import AdminLandingPage, {
  type AdminLandingCard,
} from '../../../components/admin/AdminLandingPage'

const cards: AdminLandingCard[] = [
  {
    icon: BulkIcon,
    title: 'Bulk Data Operations',
    description:
      'Retag exceptions or reclassify Xero invoices across franchise partners. Select specific FPs or run for all.',
    to: '/admin/system/admin-tools/bulk-operations',
    buttonLabel: 'Open Bulk Operations',
  },
]

const SystemAdminTools: React.FC = () => (
  <AdminLandingPage
    pageKey="adminTools"
    alert={{
      severity: 'warning',
      title: 'Caution',
      content:
        'These tools perform bulk operations on the database. Always use dry run mode first to verify changes before committing. Operations may affect system performance while running.',
    }}
    cards={cards}
  />
)

export default SystemAdminTools
